import { render, staticRenderFns } from "./login-history.vue?vue&type=template&id=2b9ba1f9&scoped=true&"
import script from "./login-history.vue?vue&type=script&lang=js&"
export * from "./login-history.vue?vue&type=script&lang=js&"
import style0 from "./login-history.vue?vue&type=style&index=0&id=2b9ba1f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9ba1f9",
  null
  
)

export default component.exports